import React, { useState, useEffect } from 'react';
import AvatarSlider from '../../../baseComponents/AvatarSlider';

const Backgrounds = ({
  backgrounds = [],
  avatar = null,
  current = null,
  onChange = () => null,
  title = ''
}) => {
  const [avatares, setAvatares] = useState([])

  useEffect(() => {
    let avatares = backgrounds.map(background => ({
      ...background,
      avatar: avatar ? avatar.avatar : null
    }));
    setAvatares(avatares);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatar]);

  return <div>
    <div className='new_stream__slider_block'>
      <label className='stream__settings_block_title font_azo'>{title}</label>
    </div>
    <AvatarSlider
      type='square'
      showAvatar={false}
      showBackground={true}
      isLoading={false}
      avatares={avatares}
      avatarSelected={current.id}
      setAvatarSelected={onChange}
    />
  </div>;
};

export default Backgrounds;